<script setup>
import {computed, reactive} from 'vue'

  const icons = reactive({});
  const icon_visible = computed(()=>{
    let show = false;
    let icons_keys = Object.keys(icons);
    icons_keys.forEach((icon_class) => {
      if(icons[icon_class] === true){
        show = true;
        return show;
      }
    });
    return show;
  })
  const setIcons = function (icons_set){
    Object.assign(icons,icons_set);
  };
  defineExpose({setIcons});

</script>

<template>
  <header class="row w-100 justify-content-center header position-fixed start-0 top-0 z-3 g-0 shadow">
      <div class="col">
        <img src="../../images/presentd_logo_mouse.svg" alt="PresentD - Dallmeier electronic Presentations" class="logo">
        <i class="icon header mx-auto" :class="icons" v-show="icon_visible"></i>
      </div>
    </header>
</template>